const currencyFormatter = new Intl.NumberFormat("en-KE", {
  style: "currency",
  currency: "KES",
  maximumFractionDigits: 2,
});

const safeNumber = (value) => {
  const numericValue = Number(value);
  return Number.isFinite(numericValue) ? numericValue : 0;
};

export const formatCurrency = (value) => currencyFormatter.format(safeNumber(value));

export const toInputDateValue = (value) => {
  const date = value instanceof Date ? value : new Date(value);

  if (Number.isNaN(date.getTime())) {
    return "";
  }

  return date.toISOString().slice(0, 10);
};

export const formatDateLabel = (value) => {
  if (!value) {
    return "—";
  }

  const date = new Date(value);

  if (Number.isNaN(date.getTime())) {
    return value;
  }

  return new Intl.DateTimeFormat("en-KE", {
    dateStyle: "medium",
    timeStyle: "short",
  }).format(date);
};

export const buildReportSummary = (rows = []) => {
  const summary = {
    totalCount: rows.length,
    failed: 0,
    successful: 0,
    deposits: 0,
    payments: 0,
    charges: 0,
  };

  rows.forEach((row) => {
    const amount = safeNumber(row.amount);
    const chargeAmount = safeNumber(row.chargeAmount);

    if (Number(row.status) === 2) {
      summary.successful += 1;

      if (row.transactionType === "Payment") {
        summary.payments += amount;
        summary.charges += chargeAmount;
      } else {
        summary.deposits += amount;
      }
    } else {
      summary.failed += 1;
    }
  });

  return summary;
};

export const getStatusMeta = (status, statusMessage = "") => {
  const numericStatus = Number(status);

  if (numericStatus === 2) {
    return { label: "Successful", tone: "success" };
  }

  if (numericStatus === 8) {
    return { label: "Pending retry", tone: "warning" };
  }

  if (numericStatus === 4) {
    return { label: "Failed", tone: "danger" };
  }

  if (numericStatus === 1) {
    return { label: "Queued", tone: "neutral" };
  }

  if (statusMessage) {
    return { label: statusMessage, tone: "neutral" };
  }

  return { label: `Status ${status}`, tone: "neutral" };
};
